import Hero from "../components/Hero";
import HeroImage from "../../assets/images/HomeInsurance1.jpg";
import homeInsurancePageImage from "../../assets/images/HomeInsurance2.jpg";
import Accordion from "../designSystem/Accordion";

const HomeInsurancePage = () => {
  return (
    <div className="home-page">
      <Hero
        title="Home Insurance"
        titleAlign="center"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="center"
        lightOverlay={true}
      />
      <section className="grey-container">
        <div className="grey-container-content">
          <div className="row">
            <div className="content-column">
              <h2 className="burgandy align-left">What is Home Insurance?</h2>
              <div className="divider burgandy align-left" />
              <div className="content grey align-left">
                Home insurance protects your property and belongings against
                risks such as theft, fire, and weather damage. It helps
                safeguard both your home and the things inside it.
              </div>
            </div>
            <img
              src={homeInsurancePageImage}
              alt="WPP Financial Services Building"
              className="image-container"
            />
          </div>
        </div>
      </section>
      <section className="white-container">
        <div className="white-container-content">
          <div className="column">
            <h2 className="burgandy">Types of Home Insurance</h2>
            <div className="divider burgandy" />
            <Accordion title="Buildings Insurance">
              Covers the structure of your home, including walls, roof, floors,
              and fitted fixtures (e.g. kitchens and bathrooms). It’s usually
              required for homeowners and should reflect the rebuild cost of
              your property.
            </Accordion>
            <Accordion title="Contents Insurance">
              Protects your personal belongings such as furniture, clothes, and
              electronics against loss, theft, or damage. Higher-value items may
              need to be specified.
            </Accordion>
            <Accordion title="Combined Insurance">
              A single policy that covers both your building and contents—ideal
              for homeowners living in their property.
            </Accordion>
            <Accordion title="What Do You Need?">
              <ul>
                <li>
                  Homeowners: Buildings insurance is essential; contents cover
                  is recommended
                </li>
                <li>
                  Tenants: Contents insurance only (the landlord insures the
                  building)
                </li>
                <li>Landlords: Specialist cover may be required</li>
              </ul>
            </Accordion>
            <Accordion title="Important Considerations">
              <ul>
                <li>
                  Ensure accurate valuations for rebuild cost and contents
                </li>
                <li>Check policy limits and exclusions carefully</li>
                <li>Consider cover for high-value items</li>
              </ul>
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomeInsurancePage;
